import { ForumUser } from '@/app/models/forum/new-forum.model'
import { LuxUserAvatar } from '@lux/wardrobe-lib'
import './ForumDistributionUserItem.scss'

export interface ForumDistributionUserItem extends ForumUser {
    onRemove: (id: string) => void
    onAdd?: (id: string) => void
}

const ForumDistributionUserItem = ({
    firstname,
    lastname,
    nickname,
    avatarImage,
    userId,
    disabled,
    onRemove,
    onAdd
}: ForumDistributionUserItem) => {
    const className = 'smart-modals-forum-distribution-user-item'
    return (
        <div className={className}>
            <div className={`${className}__info-container ${disabled ? 'disabled' : ''}`}>
                <LuxUserAvatar
                    userName={firstname}
                    userLastname={lastname}
                    userNickname={nickname}
                    avatarImage={avatarImage}
                    size={24}
                />
                <div className={`${className}__info`}>
                    <div className="text bold">
                        {userId}
                    </div>
                    <div className="text">{nickname ? nickname : firstname} {nickname ? '' : ' ' + lastname}</div>
                </div>
            </div>
            {!disabled && <div className="link-mini" onClick={onRemove.bind(null, userId)}>Remove</div>}
            {disabled && <div className="link-mini" onClick={onAdd.bind(null, userId)}>Add</div>}
        </div>
    )
}

export default ForumDistributionUserItem
